<template lang="pug">
	.asset-image-generation-info(v-if="showed && generation" v-window)
		.card
			.card-header
				i.fa.fa-magic
				span Generation Info
				span.date {{new Date(generation['start_time']).toLocaleDateString()}} {{new Date(generation['start_time']).toLocaleTimeString()}}
			.card-body.collapse.show
				.form-line.generation.separator
					.images(ref="images" :class="{centered: !isOverflow}" @wheel="scrollGenerations($event)" @scroll="updateScrollTrack()")
						.image(v-for="(image, index) in generation['result_images']" :style="{backgroundImage: `url(generations/${image.fileName})`}" @click="editImage(index)")
					.images-scroll
						.images-thrumb(v-show="isOverflow" :style="{width: scrollWidth + 'px', left: scrollLeft + 'px'}")
				AssetImageGenerationSettings(ref="settings" :readOnly="true")
				.form-actions
					button.btn.btn-danger(type="button" @click="deleteGeneration($event)")
						i.fa.fa-remove
						span Delete generation
					button.btn.btn-dark.right-button(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 								from '../../mixins/screen'

	import AssetImageGenerationSettings			from './AssetImageGenerationSettings'

	export default {
		name: "AssetImageGenerationInfo",
		mixins: [Screen],
		screen: {
			updateOn: [

			],
			events: {
				"Show AssetImageGenerationInfo": function(variation, generation, asset) {

					this.variation = variation;
					this.generation = generation;
					this.asset = asset;

					this.creative = Creative.SelectedCreative;

					this.update();

				}
			}
		},
		components: {
			AssetImageGenerationSettings
		},
		data() {

			this.generation = null;
			this.asset = null;

			return {
				isOverflow: false,
				scrollWidth: 100,
				scrollLeft: 0
			}

		},
		methods: {
			collectData() {

				this.$nextTick(() => {

					this.updateScrollTrack();

					console.log('setSettings', {
						vendorCodename: this.generation['vendor_codename'],
						modelCodename: this.generation['model_codename'],
						styleCodenames: this.generation['style_codenames'],
						sizeCodename: this.generation['size_codename'],
						count: this.generation['count'],
						prompt: this.generation['prompt'],
						promptEnhancement: this.generation['prompt_enhancement']
					});

					if (this.$refs["settings"]) this.$refs["settings"].setSettings({
						vendorCodename: this.generation['vendor_codename'],
						modelCodename: this.generation['model_codename'],
						styleCodenames: this.generation['style_codenames'],
						sizeCodename: this.generation['size_codename'],
						count: this.generation['count'],
						prompt: this.generation['prompt'],
						promptEnhancement: this.generation['prompt_enhancement']
					});

				});

			},
			scrollGenerations(e) {

				if (e.deltaY !== 0) {

					e.preventDefault();

					this.$refs["images"].scrollLeft += e.deltaY * 3;

				}

			},
			updateScrollTrack() {

				this.isOverflow = this.$refs["images"].scrollWidth > this.$refs["images"].clientWidth;

				if (this.isOverflow) {

					this.scrollWidth = (this.$refs["images"].clientWidth / this.$refs["images"].scrollWidth) * this.$refs["images"].clientWidth;
					this.scrollLeft = (this.$refs["images"].scrollLeft / (this.$refs["images"].scrollWidth - this.$refs["images"].clientWidth)) * (this.$refs["images"].clientWidth - this.scrollWidth);

				}

			},
			editImage(index) {

				Broadcast.call("Show AssetImageInfo", [this.creative, this.asset, this.variation, this.variation.images[index]]);

			},
			deleteGeneration(e) {

				Broadcast.call('Show Confirm', [{
					caption: 'Delete generation',
					message: `Are you sure you want to delete this generation?`,
					confirmButtonText: '&nbsp;&nbsp;Delete generation',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {
						Server.sendToSocket({
							DeleteGeneration: {
								assetGenerationId: this.generation.id
							}
						});
						this.closeWindow();
					}
				}]);

			}
		}
	}
</script>


<style lang="sass">

	.asset-image-generation-info
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 940px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			button
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				color: #fff

			.btn-link
				color: #fff

			.btn-link:hover
				color: #fff

			.card-header
				display: flex
				flex-direction: row

				.date
					color: rgba(255,255,255,0.1)
					margin-left: auto

		.form-group
			display: flex
			flex-direction: column
			margin: 0

			&:first-child
				margin-left: 0

		.form-line
			display: flex
			flex-direction: row

		.generation
			flex-direction: column
			padding-bottom: 7px

		.images
			display: flex
			flex-direction: row
			overflow-x: auto
			scrollbar-width: none
			-ms-overflow-style: none
			scroll-behavior: smooth

			&::-webkit-scrollbar
				display: none

			&.centered
				justify-content: center

			.image
				flex-shrink: 0
				width: 250px
				height: 250px
				background-position: center
				background-size: contain
				background-repeat: no-repeat
				border-radius: 5px
				overflow: hidden
				border: 1px solid var(--gray-dark)
				box-shadow: 0px 0px 5px var(--gray-dark)
				cursor: pointer
				margin-left: 10px

				&:hover
					border-color: var(--primary)

			.image:first-child
				margin-left: 0

		.images-scroll
			display: flex
			position: relative
			width: 100%
			height: 8px
			margin-top: 6px
			border-radius: 5px

			.images-thrumb
				position: absolute
				left: 0
				height: 8px
				background-color: rgba(0,0,0,0.1)
				border-radius: 5px

		.form-actions
			display: flex
			flex-direction: row
			align-items: center
			margin-top: 20px

			.right-button
				margin-left: auto

</style>

